import Avatar from "@material-ui/core/Avatar";
import React from "react";
import { getProfilePicUrl } from "../../services/api";
import { formatWhatsApp } from "./whatsappFormat";


/** Texto de un mensaje con el formato de WhatsApp. `inline`: vista previa de una línea (lista de tickets). */
const MarkdownWrapper = ({ children, message, inline = false }) => {
	let type = message?.mediaType;
	const formatted = React.useMemo(() => (children ? formatWhatsApp(children, { inline }) : null), [children, inline]);

	if (!children) return null;
	const regex = /(?<=FN:)(.*)(?=\n)|(?<=TEL;.*:)(.*)(?=\n)/g;

	// Executar a expressão regular na string do vCard
	const matches = children.match(regex);

	// Extrair o nome e o número de telefone
	const contact = matches ? matches[0] : '';
	const number = matches ? matches[1] : '';
	const vcardStyle = {
		backgroundColor: 'rgb(74 222 128)',
		border: '1.5px solid green',
		borderRadius: '4px',
		width: '300px',
		display: 'flex',
		alignItems: 'center',
		padding: '5px 0',
	};

	const avatar = {
		marginLeft: '10px',
	};

	const infoStyle = {
		marginLeft: '10px',
	};
	const p = {
		margin: '2px',
	}


	if (type === 'contactMessage') {
		return (
			<div style={vcardStyle}>
				<Avatar 
					style={avatar} 
					src={getProfilePicUrl(message.contact.profilePicUrl)} 
					alt="contact_image"
					onError={(e) => {
						e.target.style.display = 'none';
					}}
				/>
				<div style={infoStyle}>
					<p style={p}><strong>Nome:</strong> {contact}</p>
					<p style={p}><strong>Número:</strong> {number}</p>
				</div>
			</div>
		)
	}
	return <>{formatted}</>;
};

export default MarkdownWrapper;
